import { combineReducers } from "redux";
import { withResetState } from "../../../wrapperReducer";
import commonReducer from "../../commonReducer/commonReducer";
import drivingMarketParamsReducer, { initVolumeState } from "../common/params";
import volumeBuzzer from "./volumeBuzzer";
export default combineReducers({
    reducersData: volumeBuzzer,
    commonData: commonReducer,
    paramsData: withResetState(initVolumeState)(drivingMarketParamsReducer),
});
